import { StackProps, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  children: any;
}

export default function Container({ children, ...props }: Props) {
  return (
    <VStack
      gap={0}
      w={"100%"}
      maxW={"1280px"}
      px={[4, null, 6]}
      align={"stretch"}
      {...props}
    >
      {children}
    </VStack>
  );
}
